'use client';

import React from 'react';

const skeletonColor = 'bg-[#E5DDD5]';

const DetailPageLoader = () => {
  return (
    <div className="min-h-screen px-6 py-8 lg:px-0 mt-4">
      {/* Title skeleton */}
      <div
        className={`bg-background-secondary h-10 w-72 rounded-lg mb-6 mt-16 animate-pulse`}
      />

      {/* Main content grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {/* Left side - Medium card */}
        <div
          className={`bg-background-secondary lg:rounded-card w-full h-[400px] lg:h-[500px] animate-pulse`}
          style={{ animationDelay: '100ms' }}
        />

        {/* Right side - Tall card + two smaller cards */}
        <div className="flex flex-col gap-5">
          {/* Tall card */}
          <div
            className={`bg-background-secondary lg:rounded-card w-full h-[500px] lg:h-[600px] animate-pulse`}
            style={{ animationDelay: '200ms' }}
          />

          {/* Two smaller cards side by side */}
          <div className="grid grid-cols-2 gap-5">
            <div
              className={`bg-background-secondary rounded-xl w-full h-[180px] lg:h-[200px] animate-pulse`}
              style={{ animationDelay: '300ms' }}
            />
            <div
              className={`bg-background-secondary rounded-xl w-full h-[180px] lg:h-[200px] animate-pulse`}
              style={{ animationDelay: '400ms' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailPageLoader;
